export default {
    apiKey: "AIzaSyBbl5IvP3zqqERnVopR3b2SN6UzA5uVEOA",
    authDomain: "persuaid-copy.firebaseapp.com",
    projectId: "persuaid-copy",
    storageBucket: "persuaid-copy.appspot.com/",
    appId: "1:58965255703:web:97427ed4348a088c491e52",
};
